var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.091,
    height: 40.5,
    viewBox: "0 0 52.091 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3147.628,9369.57v-2.6h11.082v-4.154h-6.095v-2.594h6.095v-2.6h-6.095v-2.6h6.095v-2.6h-6.095v-2.593h6.095v-4.154h-11.082v-2.6h13.853v26.482Zm-22.167,0v-36.348h20.5v36.348Zm14.41-9.865v7.268h3.324V9335.82h-14.962v31.152h3.326v-7.268Zm-5.542,7.268h2.771V9362.3h-2.771Zm-24.938,2.6v-26.482H3123.8v2.6h-11.639v4.154h6.65v2.593h-6.65v2.6h6.65v2.6h-6.65v2.6h6.65v2.594h-6.65v4.154h11.084v2.6Zm27.709-12.463v-2.6h2.769v2.6Zm-5.542,0v-2.6h2.771v2.6Zm5.542-5.193v-2.594h2.769v2.594Zm-5.542,0v-2.594h2.771v2.594Zm5.542-5.709v-2.6h2.769v2.6Zm-5.542,0v-2.6h2.771v2.6Zm16.071-4.674v-2.6h13.853v2.6Zm-38.238,0v-2.6H3123.8v2.6Zm27.709-.521v-2.594h2.769v2.594Zm-5.542,0v-2.594h2.771v2.594Zm-6.1-9.342v-2.6h20.5v2.6Z",
    transform: "translate(-3109.39 -9329.07)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCompany);
export default __webpack_public_path__ + "static/media/new_company.52a97a1d.svg";
export { ForwardRef as ReactComponent };